import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Helpers } from '../../../helpers';
import { Globals } from "../../../globals"
import * as CryptoJS from 'crypto-js';

declare let mLayout: any;
@Component({
    selector: "app-header-nav",
    templateUrl: "./header-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class HeaderNavComponent implements OnInit, AfterViewInit {
    encrypt: string;
    decrypt: string;
    public auth: any;
    constructor(private _global: Globals) {

    }

    ngOnInit() {
        this.encrypt = localStorage.getItem('auth');
        this.decrypt = CryptoJS.AES.decrypt(this.encrypt, this._global.key_aes).toString(CryptoJS.enc.Utf8);
        this.auth = JSON.parse(this.decrypt);
    }

    ngAfterViewInit() {
        mLayout.initHeader();
    }

}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/header-nav/header-nav.component.ts